/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../core/has.js";

var a = function a() {
  return !!e("enable-feature:force-wosr");
},
    r = function r() {
  return !!e("enable-feature:disable-context-navigation");
},
    t = function t() {
  return !!e("enable-feature:direct-3d-object-feature-layer-display");
};

export { r as disableContextNavigation, t as enableDirect3DObjectFeatureLayerDisplay, a as enableWebStyleForceWOSR };